module.exports = __webpack_public_path__ + "img/9791158888367.67e64ad7.jpg";